module.exports = __webpack_public_path__ + "static/media/BANANA-SUSHI-BNB.fcd9d43e.svg";